import { render, staticRenderFns } from "./ImportMerchant.vue?vue&type=template&id=53fc3d04&scoped=true&"
import script from "./ImportMerchant.vue?vue&type=script&lang=js&"
export * from "./ImportMerchant.vue?vue&type=script&lang=js&"
import style0 from "./ImportMerchant.vue?vue&type=style&index=0&id=53fc3d04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fc3d04",
  null
  
)

export default component.exports